import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { WithdrawalItemDesktop } from './Desktop';
import { WithdrawalItemMobile } from './Mobile';
import { WithdrawalItemTablet } from './Tablet';
import { WithdrawalItemTypes } from './types';

export const WithdrawalItem: React.FC<WithdrawalItemTypes.Props> = (props) => {
  return useBreakpointValue({
    base: <WithdrawalItemMobile {...props} />,
    sm: <WithdrawalItemTablet {...props} />,
    lg: <WithdrawalItemDesktop {...props} />,
  });
};
